<main class="auth-page">

  <aside class="auth-side">
    <div class="auth-side__orb auth-side__orb--top"></div>
    <div class="auth-side__orb auth-side__orb--bottom"></div>

    <div class="auth-side__content">

      <div class="auth-side__eyebrow">
        <span class="auth-side__eyebrow-icon">
          <i class="fi fi-rr-shield-check"></i>
        </span>

        <span>SECURE ACCOUNT RECOVERY</span>
      </div>

      <h2>
        აღადგინე
        <strong>ანგარიშზე წვდომა</strong>
        უსაფრთხოდ
      </h2>

      <p class="auth-side__description">
        მიუთითე Menuload-ზე რეგისტრირებული ელფოსტა და გამოგიგზავნით
        პაროლის აღდგენის ბმულს.
      </p>

      <div class="auth-feature-list">

        <div class="auth-feature">
          <span class="auth-feature__check">
            <i class="fi fi-rr-check"></i>
          </span>

          <div>
            <strong>უსაფრთხო აღდგენა</strong>

            <small>
              პაროლის შეცვლის ბმული გაიგზავნება მხოლოდ შენს
              რეგისტრირებულ ელფოსტაზე.
            </small>
          </div>
        </div>

        <div class="auth-feature">
          <span class="auth-feature__check">
            <i class="fi fi-rr-check"></i>
          </span>

          <div>
            <strong>სწრაფი პროცესი</strong>

            <small>
              რამდენიმე ნაბიჯში შეძლებ ახალი პაროლის დაყენებას.
            </small>
          </div>
        </div>

        <div class="auth-feature">
          <span class="auth-feature__check">
            <i class="fi fi-rr-check"></i>
          </span>

          <div>
            <strong>დაცული ანგარიში</strong>

            <small>
              პაროლის შეცვლის შემდეგ ძველი პაროლი აღარ იმუშავებს.
            </small>
          </div>
        </div>

      </div>

      <div class="auth-trust-card">
        <span class="auth-trust-card__icon">
          <i class="fi fi-rr-lock"></i>
        </span>

        <div>
          <strong>შენი მონაცემები დაცულია</strong>

          <small>
            Menuload იყენებს უსაფრთხო ავტორიზაციის პროცესს.
          </small>
        </div>
      </div>

    </div>
  </aside>


  <section class="auth-card">

    <header class="auth-card__header">

      <div class="auth-logo">
        M
      </div>

      <span class="auth-eyebrow">
        ACCOUNT RECOVERY
      </span>

      <h1>
        {{ 'RESETPASS' | translate }}
      </h1>

      <p>
        შეიყვანე შენი ელფოსტა და პაროლის აღდგენის ინსტრუქციას
        გამოგიგზავნით.
      </p>

    </header>


    <div
      class="auth-error"
      *ngIf="admin.error?.error?.nouser"
    >
      <i class="fi fi-rr-exclamation"></i>

      <span>
        {{ admin.error?.error?.nouser }}
      </span>
    </div>


    <form
      class="auth-form"
      [formGroup]="validateForm"
      (ngSubmit)="submitForm()"
    >

      <div class="auth-field">

        <label for="email">
          {{ 'EMAIL' | translate }}
        </label>

        <div
          class="auth-input"
          [class.auth-input--invalid]="
            error ||
            (
              emailControl?.invalid &&
              (emailControl?.dirty || emailControl?.touched)
            )
          "
        >
          <i class="fi fi-rr-envelope"></i>

          <input
            id="email"
            type="email"
            formControlName="email"
            [placeholder]="'EMAIL' | translate"
            autocomplete="email"
          >
        </div>

        <small
          class="field-error"
          *ngIf="
            emailControl?.hasError('required') &&
            (emailControl?.dirty || emailControl?.touched)
          "
        >
          ელფოსტა სავალდებულოა.
        </small>

        <small
          class="field-error"
          *ngIf="
            emailControl?.hasError('email') &&
            !emailControl?.hasError('required') &&
            (emailControl?.dirty || emailControl?.touched)
          "
        >
          მიუთითე სწორი ელფოსტა.
        </small>

        <small
          class="field-error"
          *ngIf="error"
        >
          {{ error }}
        </small>

      </div>


      <button
        type="submit"
        class="auth-submit"
        [disabled]="validateForm.invalid || load"
      >

        <span
          class="auth-submit__spinner"
          *ngIf="load"
        ></span>

        <span>
          {{
            load
              ? 'იგზავნება...'
              : ('RESETPASS' | translate)
          }}
        </span>

        <i
          class="fi fi-rr-arrow-small-right"
          *ngIf="!load"
        ></i>

      </button>

    </form>


    <footer class="auth-card__footer">

      <span>
        პაროლი გაგახსენდა?
      </span>

      <a routerLink="/signin">
        {{ 'SIGNIN' | translate }}
      </a>

    </footer>

  </section>

</main>